'use strict';

var IMask = require('imask');
var React = require('react');
var date = require('../../../helpers/date.js');
require('../../../theme/breakpoints.js');
var useIMask = require('../../../hooks/useIMask.js');
require('resize-observer-polyfill');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var IMask__default = /*#__PURE__*/_interopDefaultCompat(IMask);

const useDateMask = ({ inputRef, dateFormat = 'DD/MM/YYYY', isUTC, onChange, value, }) => {
    const parse = React.useMemo(() => date.parseDate(dateFormat, { isUTC }), [dateFormat, isUTC]);
    const format = React.useMemo(() => date.formatDate(dateFormat, { isUTC }), [dateFormat, isUTC]);
    const options = React.useMemo(() => ({
        mask: dateFormat.replace(/\//g, '{/}'),
        blocks: {
            DD: {
                mask: IMask__default.default.MaskedRange,
                from: 1,
                to: 31,
                maxLength: 2,
            },
            MM: {
                mask: IMask__default.default.MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2,
            },
            YYYY: {
                mask: IMask__default.default.MaskedRange,
                from: 0,
                to: 9999,
            },
        },
    }), [dateFormat]);
    const maskRef = useIMask.useIMaskInstance({ inputRef, options });
    useIMask.useIMaskAcceptListener(maskRef, React.useCallback(event => {
        const nextValue = maskRef.current?.unmaskedValue ?? '';
        onChange(parse(nextValue), event);
    }, [onChange, dateFormat.length, parse]));
    React.useEffect(() => {
        const mask = maskRef.current;
        const formattedValue = format(value);
        if (mask && formattedValue !== mask.unmaskedValue) {
            mask.unmaskedValue = formattedValue;
        }
    }, [value, format]);
};

exports.useDateMask = useDateMask;
//# sourceMappingURL=useDateMask.js.map
